// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"24":"a9801bdd","26":"2a4a8c46","123":"e9ceff56","341":"d32849e8","456":"852c2733","681":"5b1ca9c9"}[chunkId] + ".chunk.js";
};